import { ReactElement, useState } from 'react';
import RawDataOverviewContainer from './OverviewContainer';
import DropdownCustom from '../../controls/DropdownCustom';
import AlertGraphCell from '../AlertGraphCell';
import ZoomedAlertAnalytics from './ZommedAlertAnalytics';

const DEFAULT_DROPDOWN_PLACEHOLDER = 'Select Rule';

type AlertAnalyticsProps = {
  onZoom?: () => void;
  isZoomed?: boolean;
  onBackPress?: () => void;
  loading: boolean;
};

/**
 * GenerateDummyData function.
 * @returns - Array.
 */
const generateDummyData = (): number[] =>
  new Array(12).fill(0).map(() => Math.floor(Math.random() * 50 + 50));

/**
 * React component for AlertAnalytics.
 * @param props - Properties of AlertAnalytics component.
 * @returns - React component for AlertAnalytics.
 */
export default function AlertAnalytics(props: AlertAnalyticsProps): ReactElement {
  const { onZoom, onBackPress, isZoomed, loading } = props;
  const [selectedRule, setSelectedRule] = useState('');
  const [devicesData] = useState([
    { name: 'KA_1#5566', data: generateDummyData(), trendsChart: generateDummyData() },
    { name: 'KA_2#6655', data: generateDummyData(), trendsChart: generateDummyData() },
    { name: 'KA_2#6644', data: generateDummyData(), trendsChart: generateDummyData() }
  ]);
  /**
   * Handles changes in dropdown input values to select parameter.
   * @param selectedValue - The selected value of the parameter input change.
   */
  const handleOptionsSelectAlertRule = (selectedValue: string): void => {
    setSelectedRule(selectedValue);
  };

  const DROPDOWN_PLACEHOLDER =
    selectedRule.length > 0 ? selectedRule : DEFAULT_DROPDOWN_PLACEHOLDER;

  if (isZoomed) {
    return (
      <ZoomedAlertAnalytics
        selectedRule={selectedRule}
        setSelectedRule={setSelectedRule}
        devicesData={devicesData}
        onBackPress={onBackPress}
        loading={loading}
      />
    );
  }
  return (
    <RawDataOverviewContainer
      size="1/2"
      onZoom={onZoom}
      onBackPress={onBackPress}
      sectionName="Alert Analytics"
      zoomed={isZoomed}
      proSubscription
      loading={loading}
    >
      <div className="mt-2">
        <DropdownCustom
          onClick={handleOptionsSelectAlertRule}
          controlPlaceholder={DROPDOWN_PLACEHOLDER}
          buttons={[]}
        />
      </div>
      <div className="flex-1 flex flex-col justify-evenly dark:bg-container-700 mt-4">
        {devicesData.slice(0, 2).map((item, deviceIndex) => (
          <div className="w-full p-4 flex" key={item.name}>
            <div>
              <div className="text-gray-400 dark:text-gray-300 text-xs font-medium">
                {item.name}
              </div>
              <div className="text-gray-400 dark:text-gray-300 text-xs font-medium mt-8">Trend</div>
            </div>
            <div className="flex flex-col w-full ml-6 gap-2">
              <div className="flex gap-1 justify-between w-full">
                {item.data.map((cellValue, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <AlertGraphCell key={`alert-graph-cell-${index}`} cellValue={cellValue} />
                ))}
              </div>
              <div className="flex gap-1 justify-between w-full">
                {item.trendsChart.map((cellValue, index) => {
                  return (
                    <AlertGraphCell
                      // eslint-disable-next-line react/no-array-index-key
                      key={`alert-graph-cell-${index}`}
                      isSecondary
                      showXAxis={deviceIndex === 1}
                      cellValue={cellValue}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        ))}
      </div>
    </RawDataOverviewContainer>
  );
}
